import { LazyAction, LazyModule } from 'owa-bundling';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "InboxRule" */ './lazyIndex'));

export let lazyShowInboxRuleDialog = new LazyAction(lazyModule, m => m.showInboxRuleDialog);

export { EmailAddressWrapper };
